export enum BatchTransitionType {
  Next = 'Next',
  Previous = 'Previous',
  Hide = 'Hide',
  Closeout = 'Closeout',
}
